export enum AcademicZoneEnum {
  A = 'A',
  B = 'B',
  C = 'C',
  NONE = 'NONE'
}

export const academicZoneEnumMapping: Record<AcademicZoneEnum, string> = {
  A: 'A',
  B: 'B',
  C: 'C',
  NONE: 'Aucune'
}
